import type { AcademyAnnouncementBanner } from '~/generated_types';
import { queryClient, useDefaultMutation } from '~/lib/react-query';
import FetchPromise from '~/agent/fetch-promise';
import { academyAnnouncementBannerKeys } from './academyAnnouncementBannerKeyFactory';

interface CreateParams {
  title: string;
}

function createAcademyAnnouncementBanner(
  academyId: string,
  params: CreateParams,
): Promise<AcademyAnnouncementBanner['ADMIN']> {
  return FetchPromise.post(`academies/${academyId}/academy_announcement_banners`, params);
}

export function useCreateAcademyAnnouncementBannerMutation(academyId: string) {
  return useDefaultMutation((params: CreateParams) => createAcademyAnnouncementBanner(academyId, params), {
    onSuccess: async () => {
      await queryClient.invalidateQueries(academyAnnouncementBannerKeys.root);
    },
  });
}
